import React, { useState, useEffect } from 'react';

//Following Componing Return Timer which Starts from zero and runs until Recording is Turned OFF for Android Only
const DigitalWatch = ({ isRecording }) => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    let interval;

    if (isRecording) {
      // Start the timer when recording starts
      interval = setInterval(() => {
        setSeconds(prevSeconds => prevSeconds + 1); // Increment the time by 1 second
      }, 1000);
    } else {
      // Stop the timer when recording stops
      clearInterval(interval);
    }

    // Cleanup on unmount or when isRecording changes
    return () => {
      clearInterval(interval);
    };
  }, [isRecording]); // This effect runs when isRecording changes

  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const remainingSeconds = timeInSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
  };

  return <div>{formatTime(seconds)}</div>;
};

export default DigitalWatch;
